module.exports = __webpack_public_path__ + "static/media/agendamientosoff.8b13d7fc.svg";